<template>
    <div>
        <rkm-form
            ref="Form"
            show-legend
        >
            <rkm-row>
                <rkm-col cols="4">
                    <rkm-form-date-picker
                        range
                        :range-inline="false"
                        start-label="Período de"
                        end-label="Até"
                        v-model="model.periodo"
                        :start-validations="validations.periodo.start"
                        :end-validations="validations.periodo.end"
                    />
                </rkm-col>

                <rkm-col cols="4">
                    <rkm-form-select
                        :options="unidades"
                        label="Unidade executante"
                        show-default-option
                        text-field="unidadeNome"
                        v-model="model.unidadeId"
                        value-field="unidadeId"
                        :validations="validations.unidadeId"
                    />
                </rkm-col>

                <rkm-col cols="4">
                    <rkm-form-select
                        :options="profissionais"
                        label="Profissional executante"
                        show-default-option
                        text-field="profissionalNome"
                        v-model="model.profissionalId"
                        value-field="profissionalId"
                    />
                </rkm-col>

                <rkm-col cols="4">
                    <rkm-form-select
                        :options="profissionaisSolicitante"
                        label="Profissional solicitante"
                        show-default-option
                        text-field="profissionalNome"
                        v-model="model.medicoId"
                        value-field="profissionalId"
                    />
                </rkm-col>

                <rkm-col cols="4">
                     <rkm-form-select
                        :options="grupoExames"
                        label="Grupo de exames"
                        show-default-option
                        text-field="grupoExame"
                        v-model="model.grupoExameId"
                        :validations="validations.grupoExameId"
                        value-field="grupoExameId"
                    />
                </rkm-col>

                <rkm-col class="flex-grow-1">
                    <rkm-form-select
                        :options="exames"
                        label="Exames"
                        show-default-option
                        text-field="exameNome"
                        v-model="model.exameId"
                        value-field="exameId"
                    />
                </rkm-col>
                <rkm-col cols="auto">
                    <rkm-button
                        :label="false"
                        color="primary"
                        @click="$refs.Form.validate(search)"
                    >
                        Buscar
                    </rkm-button>

                    <rkm-button
                        :label="false"
                        @click="resetForm()"
                    >
                        Limpar
                    </rkm-button>
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <rkm-area
            title="Totais"
            type="fieldset"
            no-margin-top
            v-if="agendamentos"
        >
            <rkm-row>
                <rkm-col cols="2">
                    Paciente
                    <rkm-alert color="secondary">
                        <strong>
                            {{ totalPaciente() }}
                        </strong>
                    </rkm-alert>
                </rkm-col>

                <rkm-col cols="2">
                    Exame
                    <rkm-alert color="secondary">
                        <strong>
                            {{ totalExames() }}
                        </strong>
                    </rkm-alert>
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-area
            v-if="agendamentos"
            no-margin-top
            title="Resultado"
        >
            <template v-slot:trailing>
                <rkm-dropdown
                    class="mr-2"
                    color="primary"
                    no-caret
                    small
                    title="Colunas"
                    cols="1"
                    v-rkm-tooltip.hover
                    menu-class="auto-scroll"
                >
                    <template v-slot:button-content>
                        <rkm-icon icon="columns" />
                    </template>

                    <rkm-form-checkbox
                        :indeterminate="indeterminate"
                        @change="selectAll"
                        class="mx-2"
                        v-model="selectedAll"
                    >
                        Todas
                    </rkm-form-checkbox>

                    <rkm-form-checkbox-group
                        :options="optionalColumns"
                        class="mx-2"
                        stacked
                        text-field="label"
                        v-model="selectedCols"
                        value-field="key"
                    />
                </rkm-dropdown>

                <rkm-button
                    :disabled="agendamentos.length === 0"
                    @click="impressao()"
                    color="info"
                    small
                    title="Imprimir Listagem"
                >
                    <rkm-icon icon="print" />
                </rkm-button>

                <rkm-button
                    :disabled="agendamentos.length === 0"
                    @click="handleEtiquetaPrint()"
                    color="warning"
                    class="colorButton"
                    small
                    title="Imprimir Etiqueta"
                >
                    <rkm-icon icon="tags" />
                </rkm-button>
            </template>

            <rkm-table
                :items="agendamentos || data.model.lancamentos"
                :fields="fields"
                ref="Table"
                :sort-by="sortBy"
                :sort-desc="sortDesc"
                @sort-changed="onSortChanged"
                hide-filters
            >
                <template v-slot:cell(paciente)="row">
                    <rkm-button
                        class="mr-2"
                        color="secondary"
                        small
                        v-rkm-popover.hover.right="
                            {
                                title: 'Dados cadastrais',
                                html: true,
                                content:
                                    '<b>Prontuário:</b> ' + (row.item.prontuario || '') + '<br/>' +
                                    '<b>Data de Nascimento:</b> ' + row.item.dataNascimento + '<br/>' +
                                    '<b>Nome da Mãe:</b> ' + row.item.nomeMae + '<br/>'
                            }
                        "
                    >
                        <rkm-icon icon="user" />
                    </rkm-button>

                    <span v-if="!row.item.sequencialDesconhecido">
                        {{row.item.paciente}}

                        <template v-if="row.item.nomeSocial">
                            <template v-if="row.item.preferenciaNomeId === enums.preferenciaNome.NOME_SOCIAL">
                                <strong>({{ row.item.nomeSocial }})</strong>
                            </template>

                            <template v-else>
                                <strong>({{ row.item.nomeSocial }})</strong>
                            </template>
                        </template>
                    </span>

                    <span
                        v-else
                        class="text-primary"
                        v-rkm-popover.hover.top="
                            {
                                title: 'Características físicas',
                                content: row.item.caracteristicasFisicas
                            }
                        "
                    >
                        {{row.item.paciente}}
                    </span>
                </template>

                <template v-slot:cell(data)="row">
                    {{ row.item.data | formatDate }}
                </template>

                <template v-slot:cell(horaExame)="row">
                    {{row.item.horaExame}}
                </template>

                <template v-slot:cell(telefone)="row">
                    <template v-if="row.item.telefone == '0000000000' || !row.item.telefone">
                       -
                    </template>
                    <template v-else>
                        {{ row.item.telefone | formatPhoneOrCellPhone }}
                    </template>
                </template>

                <template v-slot:cell(nome)="row">
                    <template v-if="row.item.nome == null || row.item.nome == ''">
                       -
                    </template>
                    <template v-else>
                        {{ row.item.nome }}
                    </template>
                </template>
            </rkm-table>
        </rkm-area>
    </div>
</template>

<script>

// Vuex.
import { mapActions } from 'vuex'

// Mixins.
import { repository, error, object, data, stringCase, printEtiquetaListagem } from '@/mixins'

// Enums.
import preferenciaNome from '@/enums/cadastro/cidadao/preferenciaNome'

// Filters.
import format from '@/filters/formats'

// Moment.
import moment from 'moment'

export default {
    computed: {
        optionalColumns() {

            return this.cols.filter(c => !(c.fixed || false))
        },
        fields() {

            let fields = [
                { key: 'data', label: 'Data', sortable: true },
                { key: 'paciente', label: 'Paciente', sortable: true },
                { key: 'idade', label: 'Idade', sortable: true },
                { key: 'prontuario', label: 'Prontuário', sortable: true },
                { key: 'grupo', label: 'Grupo exame', sortable: true },
                { key: 'exame', label: 'Exame', sortable: true },
                { key: 'nome', label: 'Agendador', sortable: true },
            ]

            this.selectedCols.map(map => {
                const col = this.cols.find(find => find.key === map)
                fields.push({ key: col.key, label: col.label, sortable: true })
            })
            return fields
        },
        validations() {

            return {
                periodo: {
                    start: { required: true },
                    end: { required: true },
                },
                unidadeId: { required: true }
            }
        },
        unidades(){

            let unidadeOrigem = []

            if(this.model.periodo.start && this.model.periodo.end){

                this.resetUnidade()
                this.resetDatatable()

                const start = moment(this.model.periodo.start).subtract(1, 'day')
                const end = moment(this.model.periodo.end).add(1, 'day')

                this.data.model.lancamentos.filter(agendamento =>
                    moment(agendamento.data, 'DD/MM/YYYY').isBetween(start, end))
                        .map(unidade => {

                            let verifyUnidade = unidadeOrigem.find(u => u.unidadeId === unidade.unidadeId)

                            if(!verifyUnidade){

                                unidadeOrigem.push({

                                    unidadeId: unidade.unidadeId,
                                    unidadeNome: unidade.nomeFantasia
                                })
                            } else {

                                this.resetUnidade()
                                this.resetDatatable()
                            }
                        })
            }

            return unidadeOrigem
        },
        profissionais(){

            let profissionalOrigem = []

            if(this.model.periodo.start && this.model.periodo.end){

                this.resetProfissional()

                const start = moment(this.model.periodo.start).subtract(1, 'day')
                const end = moment(this.model.periodo.end).add(1, 'day')

                this.data.model.lancamentos.filter(u => moment(u.data, 'DD/MM/YYYY').isBetween(start, end)
                    && u.unidadeId === this.model.unidadeId)
                        .map(prof => {

                            if (profissionalOrigem){

                                let verifyProfissional = profissionalOrigem.find(u => u.profissionalId === prof.profissionalId)

                                if (!verifyProfissional) {

                                    profissionalOrigem.push({

                                        profissionalId: prof.profissionalId,
                                        profissionalNome: prof.profissionalNome,
                                    })
                                } else {

                                    this.resetProfissional()
                                }
                            }
                        })

                profissionalOrigem.sort((a,b) => (a.profissionalNome > b.profissionalNome) ? 1 : ((b.profissionalNome > a.profissionalNome) ? -1 : 0));
            }

            return profissionalOrigem
        },
        profissionaisSolicitante(){

            let medicoOrigem = []

            if(this.model.periodo.start && this.model.periodo.end){

                this.resetProfissionalSolicitante()

                const start = moment(this.model.periodo.start).subtract(1, 'day')
                const end = moment(this.model.periodo.end).add(1, 'day')

                this.data.model.lancamentos.filter(u => moment(u.data, 'DD/MM/YYYY').isBetween(start, end)
                    && u.unidadeId === this.model.unidadeId)
                        .map(prof => {

                            if (medicoOrigem){

                                let verifyProfissional = medicoOrigem.find(u => u.profissionalId === prof.medicoId)

                                if (!verifyProfissional) {

                                    medicoOrigem.push({

                                        profissionalId: prof.medicoId,
                                        profissionalNome: prof.medicoSolicitante,
                                    })
                                } else {

                                    this.resetProfissionalSolicitante()
                                }
                            }
                        })

                medicoOrigem.sort((a,b) => (a.profissionalNome > b.profissionalNome) ? 1 : ((b.profissionalNome > a.profissionalNome) ? -1 : 0));
            }

            return medicoOrigem
        },
        grupoExames(){

            let grupoExameOrigem = []

            if (this.model.periodo.start && this.model.periodo.end){

                this.resetGrupo()

                const start = moment(this.model.periodo.start).subtract(1, 'day')
                const end = moment(this.model.periodo.end).add(1, 'day')

                this.data.model.lancamentos.filter(g => moment(g.data, 'DD/MM/YYYY').isBetween(start, end)
                    && g.unidadeId === this.model.unidadeId)
                        .map(grupo => {

                            if(grupoExameOrigem){

                                let verifyGrupoExame = grupoExameOrigem.find(e => e.grupoExameId === grupo.grupoExameId)

                                if(!verifyGrupoExame){

                                    grupoExameOrigem.push({

                                        grupoExameId: grupo.grupoExameId,
                                        grupoExame: grupo.grupo
                                    })
                                } else {

                                    this.resetGrupo()
                                }
                            }
                        })

                grupoExameOrigem.sort((a,b) => (a.grupoExame > b.grupoExame) ? 1 : ((b.grupoExame > a.grupoExame) ? -1 : 0));
            }

            return grupoExameOrigem
        },
        exames(){

            let exameOrigem = []

            if(this.model.periodo.start && this.model.periodo.end){

                this.resetExames()

                const start = moment(this.model.periodo.start).subtract(1, 'day')
                const end = moment(this.model.periodo.end).add(1, 'day')

                this.data.model.lancamentos.filter(e => moment(e.data, 'DD/MM/YYYY').isBetween(start, end)
                    && e.unidadeId === this.model.unidadeId)
                        .map(exame => {

                            if (exameOrigem) {

                                let verifyExame = exameOrigem.find(u => u.exameId === exame.exameId)

                                if (!verifyExame) {

                                    exameOrigem.push({

                                        exameId: exame.exameId,
                                        exameNome: exame.exameNome,
                                    })
                                } else {

                                    this.resetExames()
                                }
                            }

                        })

                exameOrigem.sort((a,b) => (a.exameNome > b.exameNome) ? 1 : ((b.exameNome > a.exameNome) ? -1 : 0));
            }

            return exameOrigem
        },
    },
    created() {

        this.repositories = {
            listagem: this.getConectaSusRepository('exameImagem.listagemExameAgendado'),
            impressao: this.getConectaSusRepository('impressao.exameImagem'),
        },
        this.load()
    },
    data: () => ({
        model: {
            exameId: null,
            unidadeId: null,
            grupoExameId: null,
            profissionalId: null,
            medicoId: null,
            periodo: {
                start: null,
                end: null,
            },
        },
        agendamentos: null,
        selectedCols: [],
        sortBy: 'data',
        sortDesc: false,
        cols: [
            {
                key: 'data',
                label: 'Data',
                class: 'col-min',
                sortable: true,
                fixed: true
            },
            {
                key: 'paciente',
                label: 'Paciente',
                class: 'col-min',
                sortable: true,
                fixed: true
            },
            {
                key: 'idade',
                label: 'Idade',
                class: 'col-min',
                sortable: true,
                fixed: true
            },
            {
                key: 'prontuario',
                label: 'Prontuário',
                class: 'col-min',
                sortable: true,
                fixed: true
            },
            {
                key: 'telefone',
                label: 'Telefone',
                class: 'col-min',
                sortable: true
            },
            {
                key: 'profissional',
                label: 'Profissional executante',
                class: 'col-min',
                sortable: true
            },
            {
                key: 'grupo',
                label: 'Grupo exame',
                class: 'col-min',
                sortable: true,
                fixed: true
            },
            {
                key: 'exame',
                label: 'Exame',
                class: 'col-min',
                sortable: true,
                fixed: true
            },
            {
                key: 'horaExame',
                label: 'Horário',
                class: 'col-min',
                sortable: true,
            },
            {
                key: 'unidadeSolicitanteNome',
                label: 'Unidade solicitante',
                class: 'col-min',
                sortable: true,
            },
            {
                key: 'medicoSolicitante',
                label: 'Profissional solicitante',
                class: 'col-min',
                sortable: true
            },
            {
                key: 'nome',
                label: 'Agendador',
                class: 'col-min',
                sortable: true,
                fixed: true
            }
        ],
        indeterminate: false,
        enums: { preferenciaNome },
        fieldsImpressao:[],
        selectedAll: false,
    }),
    mixins: [repository, error, object, data, stringCase, printEtiquetaListagem],
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.model.periodo.start = this.data.model.periodo.start
            this.model.periodo.end = this.data.model.periodo.end
        },
        search() {

            this.setLoading()

            this.repositories.listagem.datatable(this.getSearchParams())
                .then(({ data }) => {

                    this.agendamentos = data
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        setDefaultValues() {

            this.model.periodo.start = this.data.model.periodo.start
            this.model.periodo.end = this.data.model.periodo.end

            this.resetDatatable()
        },
        getSearchParams() {

            const params = this.clone(this.model)

            this.formateDates(params.periodo, ['start', 'end'], 'DD/MM/YYYY')
            this.formateDates(params, ['dataNascimento'], 'DD/MM/YYYY')

            return this.camelObjectKeysToSnakeRecursive(params)
        },
        resetDatatable(){

            this.agendamentos = null
        },
        resetUnidade(){

            this.model.unidadeId = null
        },
        resetProfissional(){

            this.model.profissionalId = null
        },
        resetProfissionalSolicitante(){

            this.model.medicoId = null
        },
        resetGrupo(){

            this.model.grupoExameId = null
        },
        resetExames(){

            this.model.exameId = null
        },
        resetForm() {

            this.data.model.periodo.start = this.clone(this.data.initials.model.periodo.start)
            this.data.model.periodo.end = this.clone(this.data.initials.model.periodo.end)
            this.data.model.paciente = this.data.initials.model.paciente
            this.data.model.dataNascimento = this.clone(this.data.initials.model.dataNascimento)
            this.data.model.atendimento = this.data.initials.model.atendimento
            this.data.model.prontuario = this.data.initials.model.prontuario

            this.$nextTick()
                .then(() => {

                    this.setDefaultValues()
                    this.$refs.Form.resetValidator()
                })
        },
        selectAll(selected) {

            this.selectedCols = selected ? this.optionalColumns.filter(item => item.disabled !== true).map(c => c.key) : []
        },
        impressao(){

            this.setLoading()

            const filter = this.getFilterExportPrint()

            filter.columns = this.fieldsImpressao

            this.repositories.impressao.listagem(filter)
                .then(response => {

                    const content = new Blob([response.data], {type: response.headers['content-type']})
                    const url = URL.createObjectURL(content)
                    const link = document.createElement('a')

                    link.href = url
                    link.target = '_blank'
                    link.click()
                    link.remove()
                })
                .finally(() => this.unsetLoading())
        },
        getFilterExportPrint() {

            const filter = this.getSearchParams()

            const $this = this

            const cols = this.fieldsImpressao.map(function (field) {

                field.key = $this.camelToSnake(field.key)

                return field
            })

            filter.columns = cols

            filter.sortBy = this.sortBy ? this.camelToSnake(this.sortBy) : null
            filter.sortDesc = this.sortDesc

            const unidade = this.data.form.unidades.find(u => u.id === this.model.unidadeId)
            filter.unidade = unidade ? unidade.nomeFantasia : 'Todas'

            const grupo = this.data.form.grupos.find(g => g.id === this.model.grupoExameId)
            filter.grupo = grupo ? grupo.nome : 'Todos'

            const exame = this.data.form.exames.find(e => e.id === this.model.exameId)
            filter.exame = exame ? exame.nome : 'Todos'

            const profissional = this.data.form.profissionais.find(p => p.id === this.model.profissionalId)
            filter.profissional = profissional ? profissional.nome : 'Todos'

            const medico = this.data.form.profissionais.find(p => p.id === this.model.medicoId)
            filter.medico = medico ? medico.nome : 'Todos'

            return filter
        },
        handleEtiquetaPrint() {

            let buscaListagem = this.agendamentos

            let etiqueta = {
                listagem: buscaListagem
            }

            this.print().etiqueta(etiqueta)
        },
        totalPaciente(){
            return  [...new Set(this.agendamentos.map(item => item.pacienteId))].length
        },
        totalExames(){

            return  [...new Set(this.agendamentos)].length
        },
        onSortChanged(context) {

            this.sortBy = context.sortBy
            this.sortDesc = context.sortDesc
        }
    },
    watch: {
         selectedCols(newValue) {

            this.selectedAll = newValue.length > 0
                && newValue.length == this.optionalColumns.filter(item => item.disabled !== true).length

            this.indeterminate = newValue.length > 0
                && newValue.length != this.optionalColumns.filter(item => item.disabled !== true).length
        },

        fields:{
            immediate:true,
            handler(newVal){
                this.fieldsImpressao = JSON.parse(JSON.stringify(newVal))
            }
        }
    },
    filters: {
        ...format,
    },
    props: {
        data: { type: Object, required: true }
    }
}
</script>

<style scoped>
.warning {
    color: var(--warning);
}
.colorButton {
    color: #fff;
}
</style>